module.exports = __webpack_public_path__ + "img/state-icon.0fbb44a2.svg";